/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetNotificationResponse
 */
export interface GetNotificationResponse {
    /**
     * 
     * @type {string}
     * @memberof GetNotificationResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetNotificationResponse
     */
    type: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNotificationResponse
     */
    title: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNotificationResponse
     */
    message: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetNotificationResponse
     */
    isRead: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetNotificationResponse
     */
    readAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetNotificationResponse
     */
    createdAt: Date | null;
}

/**
 * Check if a given object implements the GetNotificationResponse interface.
 */
export function instanceOfGetNotificationResponse(value: object): value is GetNotificationResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('isRead' in value) || value['isRead'] === undefined) return false;
    if (!('readAt' in value) || value['readAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function GetNotificationResponseFromJSON(json: any): GetNotificationResponse {
    return GetNotificationResponseFromJSONTyped(json, false);
}

export function GetNotificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNotificationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'title': json['title'],
        'message': json['message'],
        'isRead': json['isRead'],
        'readAt': (json['readAt'] == null ? null : new Date(json['readAt'])),
        'createdAt': (json['createdAt'] == null ? null : new Date(json['createdAt'])),
    };
}

export function GetNotificationResponseToJSON(json: any): GetNotificationResponse {
    return GetNotificationResponseToJSONTyped(json, false);
}

export function GetNotificationResponseToJSONTyped(value?: GetNotificationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'title': value['title'],
        'message': value['message'],
        'isRead': value['isRead'],
        'readAt': value['readAt'] == null ? value['readAt'] : value['readAt'].toISOString(),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
    };
}

